import ErrorBubble from './ErrorBubble'

export default ErrorBubble
